import React from "react";
import { Search, Home, FileCheck, ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function HowItWorks() {
  const navigate = useNavigate();

  const steps = [
    {
      step: "01",
      title: "Book Test or Upload Rx",
      description: "Search from 100+ diagnostic tests or health packages, or simply upload your doctor prescription in 1 click.",
      icon: <Search size={26} />,
      color: "from-blue-500 to-indigo-600",
    },
    {
      step: "02",
      title: "Free Sample Home Pickup",
      description: "Certified DMLT phlebotomist arrives at your doorstep on time with sealed temperature-controlled sample kits.",
      icon: <Home size={26} />,
      color: "from-rose-500 to-red-600",
    },
    {
      step: "03",
      title: "Get Reports in 6 Hours",
      description: "Receive 100% accurate, NABL-certified smart digital lab reports on WhatsApp, Email, and your Profile dashboard.",
      icon: <FileCheck size={26} />,
      color: "from-emerald-500 to-teal-600",
    }
  ];

  return (
    <div className="w-full py-10 px-4 md:px-8 bg-gradient-to-br from-slate-50 via-white to-red-50/20 rounded-3xl border border-gray-100 shadow-sm mt-6">
      <div className="text-center max-w-2xl mx-auto mb-10">
        <span className="inline-flex items-center gap-1 text-[11px] font-bold tracking-wider uppercase text-red-600 bg-red-50 px-3 py-1 rounded-full mb-2">
          Simple 3-Step Process
        </span>
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-extrabold text-gray-900">
          How <span className="bg-gradient-to-r from-red-600 to-rose-600 bg-clip-text text-transparent">NewMed</span> Works
        </h2>
        <p className="text-xs md:text-sm text-gray-500 mt-2">
          From doorstep sample collection to accurate digital reports, experience hassle-free healthcare
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 relative">
        {steps.map((item, index) => (
          <div 
            key={index}
            className="group relative bg-white p-6 rounded-2xl border border-gray-100 hover:border-red-200 shadow-sm hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1.5"
          >
            <div className="flex items-center justify-between mb-4">
              <div className={"w-14 h-14 rounded-2xl bg-gradient-to-br " + item.color + " text-white flex items-center justify-center shadow-md group-hover:scale-110 transition-transform duration-300"}>
                {item.icon}
              </div>
              <span className="text-3xl font-black text-gray-200 group-hover:text-red-200 transition-colors">
                {item.step}
              </span>
            </div>

            <h3 className="text-lg font-bold text-gray-900 mb-2 group-hover:text-red-600 transition-colors">
              {item.title}
            </h3>
            <p className="text-xs text-gray-500 leading-relaxed">
              {item.description}
            </p>
          </div>
        ))}
      </div>

      <div className="mt-8 pt-6 border-t border-gray-100 flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-2 text-xs text-gray-600">
          <span className="w-2 h-2 rounded-full bg-emerald-500"></span>
          <span>100% Free Home Sample Collection on all Orders above ₹299</span>
        </div>
        <button
          onClick={() => navigate("/all-tests")}
          className="w-full sm:w-auto px-6 py-2.5 bg-gradient-to-r from-red-500 to-rose-600 text-white rounded-xl text-xs font-bold hover:from-red-600 hover:to-rose-700 transition-all shadow-md shadow-red-200 flex items-center justify-center gap-2"
        >
          <span>Book a Home Test Now</span>
          <ArrowRight size={14} />
        </button>
      </div>
    </div>
  );
}
